export default __webpack_public_path__ + "static/media/120_sporofungus_kawai_0001.ce3ed85a.png";